:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._loader_68gw2_7 {
  background: #fff;
  z-index: 1999; }

._panel_68gw2_11 .control-base-modal {
  max-height: 96vh; }

._panel_68gw2_11 .control-base-modal .control-base-modal-body {
  padding-bottom: 0; }

._panel_68gw2_11 .control-base-modal .control-base-modal-header {
  border-top: 0; }

._panel_68gw2_11 .control-custom-modal.control-custom-modal
.control-custom-modal-content-wrapper {
  overflow: visible; }

._panel_opt_68gw2_26 .control-base-modal {
  margin: 30px; }

._panel_opt_68gw2_26 .control-base-modal .control-base-modal-header {
  padding-top: 0; }

._panel_opt_68gw2_26 .control-base-modal-header-btn-bar > button {
  background: transparent !important; }

._panel_opt_68gw2_26 .control-custom-modal.control-custom-modal
.control-custom-modal-content-wrapper {
  display: flex;
  height: 100%;
  padding: 0; }

._panel_opt_68gw2_26 ._form_68gw2_43 {
  padding-top: 30px;
  width: 50vw;
  height: 64vh;
  min-width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between; }
  @media (max-height: 965px), (max-width: 1288px), (min-height: 965px) {
    ._panel_opt_68gw2_26 ._form_68gw2_43 {
      height: 100%; } }

._panel_opt_68gw2_26 ._title_68gw2_55 {
  padding: 18px 84px 18px 54px; }

._panel_opt_68gw2_26 ._row_68gw2_58 > .composite-text-input-multiline-labeled {
  padding-top: 6px; }

._panel_opt_68gw2_26 ._row_68gw2_58 > .composite-text-input-labeled {
  padding-top: 0; }

@media (max-width: 800px) {
  ._panel_opt_68gw2_26 ._row_68gw2_58 > .composite-text-input-multiline-labeled .input-container,
  ._panel_opt_68gw2_26 ._row_68gw2_58 > .composite-text-input-multiline-labeled .input {
    height: 60px !important; } }

._form_68gw2_43 {
  width: 600px; }

._title_68gw2_55 {
  position: relative;
  padding: 30px 84px 18px 54px; }
  ._title_68gw2_55 .control-badge {
    display: inline-block !important;
    margin-left: 10px;
    margin-bottom: -1px; }
  ._title_68gw2_55 .control-label-base {
    line-height: 1.3 !important; }

._icon_68gw2_82 {
  position: absolute;
  top: 28px;
  right: 47px;
  width: 34px;
  height: 26px; }

._subtitle_68gw2_89 {
  padding: 0 84px 18px 54px; }

._row_68gw2_58 {
  display: block;
  padding: 0 30px; }

._submit_68gw2_96 {
  padding-top: 30px;
  padding-bottom: 30px; }
  ._submit_opt_68gw2_99 {
    padding-top: 12px;
    padding-bottom: 30px;
    z-index: 2; }

._terms_68gw2_104 {
  padding: 12px 0;
  border-radius: 4px; }

._footer_68gw2_108 {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, #fff 88.54%);
  border-radius: 4px;
  flex-grow: 2;
  z-index: 2; }
  ._footer_68gw2_108 ._terms_68gw2_104 {
    background-color: #fff; }
